export default function googleAnalyticsMiddleware({ instantSearchInstance }) {
    const sendEvent = (query) => {
        if (typeof gtag !== "undefined") {
            gtag("event", "search", {
                search_term: query,
            });
        }
    };

    return {
        onStateChange({ uiState }) {
            for (const indexName in uiState) {
                const state = uiState[indexName];

                if (state.query) {
                    sendEvent(state.query);
                }
            }
        },
        subscribe() {},
        unsubscribe() {},
    };
}
